import { Switch } from "@/components/ui/switch";

export default function ProductUpdatesPreference({
  preferences,
  setPreferences,
  updatePreference,
  tx,
}) {
  return (
    <section className="rounded-[1.75rem] border border-border bg-card p-5 md:p-6">
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0 space-y-2">
          <h2 className="font-display text-2xl font-bold">{tx("Product updates")}</h2>
          <p className="max-w-2xl text-sm text-muted-foreground">
            {tx("Min can send useful product updates to your WhatsApp when something meaningful ships.")}
          </p>
        </div>
        <Switch
          checked={preferences.changelogUpdatesEnabled}
          onCheckedChange={(checked) => updatePreference(setPreferences, "changelogUpdatesEnabled", checked)}
          aria-label={tx("Product updates")}
        />
      </div>
    </section>
  );
}
